<div class="page-wrap height-100 black">
  <div class="session-form-hold">
    <mat-progress-bar mode="determinate" class="session-progress"></mat-progress-bar>
    <mat-card>
      <mat-card-content>
        <!-- Language Switcher -->
        <div class="session-language-select">
          <language-switcher></language-switcher>
        </div>
        <div class="text-center pt-8 pb-16">
          <img width="60px" src="assets/images/logo.png" alt="" class="mb-05">
          <p class="text-muted m-0">{{ 'New password will be sent to your email address' | translate }}</p>
        </div>
        <form [formGroup]="forgotPasswordForm" (ngSubmit)="submitEmail()">
          <div class="">
            <mat-form-field class="full-width">
              <input matInput name="email" formControlName="userEmail" placeholder="Email">
            </mat-form-field>
            <mat-error
              *ngIf="forgotPasswordForm.controls['userEmail'].hasError('required') && forgotPasswordForm.controls['userEmail'].touched"
              class="form-error-msg-large"> {{ 'Email is required' | translate }} </mat-error>
            <mat-error *ngIf="notExists && !forgotPasswordForm.controls['userEmail'].dirty"
                       class="form-error-msg-large">{{ 'Incorrect Email' | translate }}</mat-error>
            <mat-hint
              *ngIf="sent && !forgotPasswordForm.controls['userEmail'].dirty" [ngStyle]="{color: '#076d03'}"
              class="form-error-msg-large">{{ 'Password recovery instructions have been sent to your email' | translate }}</mat-hint>
          </div>

          <button mat-raised-button class="mat-primary full-width mb-1" [disabled]="forgotPasswordForm.invalid">{{ 'Submit' | translate}}</button>
          <div class="text-center">
            <a [routerLink]="'/sessions/signin_user'" class="mat-primary text-center full-width">{{ "Sign in" | translate }}</a>
            <span fxFlex></span>
            <a [routerLink]="'/sessions/signup_user'" class="mat-primary text-center full-width">{{ 'Create a new account' | translate }}</a>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
</div>

